module.exports = __webpack_public_path__ + "static/img/label-06.c2b87af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/label-06.png
// module id = y6Yf
// module chunks = 150